'use es6';

import { findIndex } from 'underscore';
import SeamlessImmutable from 'seamless-immutable';
import { MENU_TREE_LOAD, MENU_TREE_MOVE_NODE, MENU_TREE_ADD_CHILD, MENU_TREE_ADD_NODE, MENU_TREE_CLONE_NODE, MENU_TREE_DELETE_NODE, MENU_TREE_DELETE_TREE, MENU_TREE_ADD_NODE_TO_BOTTOM } from 'simple-menus-core/actions/ActionTypes';
import DropPositions from 'simple-menus-core/enums/DropPositions';
import { findNode, removeNode, findNestedParentNode } from 'simple-menus-core/utils/menuTree';
export default function MenuTree(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case MENU_TREE_LOAD:
      {
        const {
          tree,
          menuId
        } = action;
        return state.set(menuId, SeamlessImmutable(tree));
      }
    case MENU_TREE_MOVE_NODE:
      {
        const {
          nodeId,
          targetId,
          targetParentId,
          position,
          menuId
        } = action;
        if (!nodeId || nodeId === targetId || !menuId) return state;
        const tree = state[menuId].asMutable({
          deep: true
        });
        const node = findNode(nodeId, tree);
        let targetNodes = targetParentId ? findNode(targetParentId, tree).children : tree;
        removeNode(nodeId, tree);
        let spliceIndex = findIndex(targetNodes, __node => __node.id === targetId);
        // on the case where the target is nested but the targetParent isn't set we need to grab the proper target nodes to grab
        if (spliceIndex === -1) {
          targetNodes = findNestedParentNode(targetId, tree).children;
          if (targetNodes) spliceIndex = findIndex(targetNodes, __node => __node.id === targetId);
        }
        if (position === DropPositions.TOP) {
          targetNodes.splice(spliceIndex, 0, node);
        } else if (position === DropPositions.BOTTOM) {
          targetNodes.splice(spliceIndex + 1, 0, node);
        } else if (position === DropPositions.MIDDLE) {
          targetNodes[spliceIndex].children.unshift(node);
        }
        return state.set(menuId, SeamlessImmutable(tree));
      }
    case MENU_TREE_ADD_CHILD:
      {
        const {
          parentId,
          nodeId,
          treeNode,
          menuId
        } = action;
        if (!(parentId && nodeId && treeNode && menuId)) return state;
        const tree = state[menuId].asMutable({
          deep: true
        });
        const node = findNode(parentId, tree);
        node.children.unshift(treeNode);
        return state.set(menuId, SeamlessImmutable(tree));
      }
    case MENU_TREE_ADD_NODE:
    case MENU_TREE_CLONE_NODE:
      {
        const {
          parentId,
          siblingId,
          treeNode,
          position,
          menuId
        } = action;
        if (!menuId) return state;
        const tree = state[menuId].asMutable({
          deep: true
        });

        /* First node */
        if (!(parentId && siblingId) && !tree.length) {
          return state.set(menuId, SeamlessImmutable([treeNode]));
        }
        const targetNodes = parentId ? findNode(parentId, tree).children : tree;
        const spliceIndex = findIndex(targetNodes, __node => __node.id === siblingId);
        if (position === DropPositions.TOP) {
          targetNodes.splice(spliceIndex, 0, treeNode);
        } else {
          targetNodes.splice(spliceIndex + 1, 0, treeNode);
        }
        return state.set(menuId, SeamlessImmutable(tree));
      }
    case MENU_TREE_ADD_NODE_TO_BOTTOM:
      {
        const {
          treeNode,
          menuId
        } = action;
        if (!menuId) return state;
        const tree = state[menuId].asMutable({
          deep: true
        });
        return state.set(menuId, SeamlessImmutable([...tree, treeNode]));
      }
    case MENU_TREE_DELETE_NODE:
      {
        const {
          id,
          menuId
        } = action;
        if (!(id && menuId)) return state;
        const tree = state[menuId].asMutable({
          deep: true
        });
        removeNode(id, tree);
        return state.set(menuId, SeamlessImmutable(tree));
      }
    case MENU_TREE_DELETE_TREE:
      {
        const {
          menuId
        } = action;
        if (!menuId) return state;
        return state.without(menuId);
      }
    default:
      {
        return state;
      }
  }
}